import { render } from "./SignupVerifyComponent.vue?vue&type=template&id=265f4fb2"
import script from "./SignupVerifyComponent.vue?vue&type=script&lang=js"
export * from "./SignupVerifyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/auth/SignupVerifyComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "265f4fb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('265f4fb2', __exports__)) {
    api.reload('265f4fb2', __exports__)
  }
  
  module.hot.accept("./SignupVerifyComponent.vue?vue&type=template&id=265f4fb2", () => {
    api.rerender('265f4fb2', render)
  })

}


export default __exports__